import { Item } from '../item/item'

export class Order {

  order_id: number
  customer_id: number
  customer: string
  channel: string
  date: string
  shipping_fee: number
  comment: string
  items: Item[]

  constructor(data: any = {}) {
    this.order_id = data.order_id
    this.customer_id = data.customer_id
    this.customer = data.customer
    this.channel = data.channel
    this.date = data.date
    this.shipping_fee = data.shipping_fee
    this.comment = data.comment
    this.items = data.items && data.items.length ? data.items.map(x => new Item(x)) : []
  }

}



// WEBPACK FOOTER //
// ./src/app/models/finance/order.ts